import React from 'react';
import { Alert, Badge, Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import {
  ComparisonCard,
  ComparisonHeader,
  ComparisonTitle,
  ComparisonDate,
  ComparisonStats,
  ComparisonStat,
  ComparisonGrowth,
  GrowthValue,
  RightAlignedStat,
  AlertWrapper,
  StatLabel,
  StatValue,
  TrendIcon,
} from './styles';
import {
  TREND_COLORS,
  TREND_BADGE_COLORS,
  TREND_LABELS,
  TREND_ICONS,
  DISPLAY_DATE_RANGE_FORMAT,
  DISPLAY_DATE_FORMAT,
} from './constants';
import { PeriodComparisonCardProps } from './types';

const PeriodComparisonCard: React.FC<PeriodComparisonCardProps> = ({
  comparison,
  index,
}) => {
  const getTrendIcon = () => {
    const trend = comparison.trend || 'neutral';
    const icon = TREND_ICONS[trend];
    const color = TREND_COLORS[trend];

    return (
      <TrendIcon color={color}>
        <FontAwesomeIcon icon={icon} />
      </TrendIcon>
    );
  };

  const getTrendBadgeColor = () => {
    return TREND_BADGE_COLORS[comparison.trend];
  };

  const getTrendLabel = () => {
    return TREND_LABELS[comparison.trend];
  };

  return (
    <ComparisonCard>
      <ComparisonHeader>
        <div>
          <ComparisonTitle level={5}>{comparison.label}</ComparisonTitle>
          <ComparisonDate>
            {moment(comparison.startDate).format(DISPLAY_DATE_RANGE_FORMAT)} -{' '}
            {moment(comparison.endDate).format(DISPLAY_DATE_FORMAT)}
          </ComparisonDate>
        </div>
        <Space>
          {getTrendIcon()}
          <Badge status={getTrendBadgeColor() as any} text={getTrendLabel()} />
        </Space>
      </ComparisonHeader>

      {!comparison.itemFound && (
        <AlertWrapper>
          <Alert
            message="Item not found in this period"
            type="warning"
            icon={<FontAwesomeIcon icon={faExclamationCircle} />}
          />
        </AlertWrapper>
      )}

      <ComparisonStats>
        <ComparisonStat>
          <StatLabel>Times Sold</StatLabel>
          <StatValue>{comparison.totalTimesSold.toLocaleString()}</StatValue>
        </ComparisonStat>
        <RightAlignedStat>
          <StatLabel>Revenue</StatLabel>
          <StatValue color="#52c41a">
            ${comparison.totalRevenue.toLocaleString()}
          </StatValue>
        </RightAlignedStat>
      </ComparisonStats>

      <ComparisonGrowth>
        <ComparisonStat>
          <StatLabel>Volume Growth</StatLabel>
          <GrowthValue trend={comparison.trend}>
            {comparison.volumeGrowth > 0 ? '+' : ''}
            {comparison.volumeGrowth}%
          </GrowthValue>
        </ComparisonStat>
        <RightAlignedStat>
          <StatLabel>Revenue Growth</StatLabel>
          <GrowthValue trend={comparison.trend}>
            {comparison.revenueGrowth > 0 ? '+' : ''}
            {comparison.revenueGrowth}%
          </GrowthValue>
        </RightAlignedStat>
      </ComparisonGrowth>
    </ComparisonCard>
  );
};

export default PeriodComparisonCard;
